import React from 'react'
import { Popover, Transition } from '@headlessui/react'
import { QuestionMarkCircleIcon } from '@heroicons/react/outline'


function ProductEx() {
    return (
        <div>
             <Popover className="absolute">
                <Popover.Button><QuestionMarkCircleIcon className="h-4 my-1" /></Popover.Button>
                <Transition
                    enter="transition duration-100 ease-out"
                    enterFrom="transform scale-95 opacity-0"
                    enterTo="transform scale-100 opacity-100"
                    leave="transition duration-75 ease-out"
                    leaveFrom="transform scale-100 opacity-100"
                    leaveTo="transform scale-95 opacity-0"
                >
                    <Popover.Panel className="absolute z-10 bg-white rounded-lg shadows p-2 border-2 border-gray-300 w-64">
                        <div>
                            <b>Examples</b>
                            <div className="my-4">
                                <b>Zoom:</b> We help people stay connected digitally through our video meeting software.
                            </div>
                            <div className="my-4">
                                <b>Slack:</b> Slack helps teams stay in touch by bring all of their work communications into our chat software.
                            </div>
                        </div>
                    </Popover.Panel>
                </Transition>
                </Popover>
        </div>
    )
}

export default ProductEx
